/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';

export const tableStatsSchema = z.object({
  table: z.string(),
  count: z.number(),
  columns: z.number(),
});

export const databaseStatsResponseDataSchema = z.object({
  tables: z.array(tableStatsSchema),
});

export type IDatabaseStatsResponseData = z.infer<typeof databaseStatsResponseDataSchema>;

export const databaseStatsResponseSchema = createApiResponseSchema(
  databaseStatsResponseDataSchema,
) as z.ZodSchema<IAPI<IDatabaseStatsResponseData>>;

export type IDatabaseStatsResponse = IAPI<IDatabaseStatsResponseData>;
